// Colocated strings for StatusFilterFab (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by the SFC as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// Lifted verbatim from the app's `src/locales.js` `filterDialog` block and FLATTENED —
// a local scope needs no namespace. One file per locale that bundle actually has
// (10; the all-empty `defaultLocale` bundle no longer exists).
//
// The item-type LABELS (the `issues` / `processes` entries of that block) stay in the
// app: they are this dashboard's vocabulary. The app maps its item-type keys to
// `{ key, label }` and passes them in through the `itemTypes` prop.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
